import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MediaService } from '../../core/services/media.service';
import * as JSZip from 'jszip';

@Component({
  selector: 'app-single-album',
  templateUrl: './single-album.component.html',
  styleUrls: ['./single-album.component.scss'],
})
export class SingleAlbumComponent implements OnInit {
  breadcrumbs: any[] = [];
  title = '';
  createdAt = '';
  album: any[] = [];
  isVisible = false;
  mediaItem: any;
  extractedImages: string[] = [];
  extractedVideos: string[] = [];
  loading = true;

  // Modal State
  isModalOpen = false;  // Flag to control modal visibility
  selectedImage: string = '';  // Store the selected image URL

  constructor(
    private activatedRoute: ActivatedRoute,
    private mediaService: MediaService
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.mediaService.getAlbumsById(id).then((res) => {
        this.title = res.title;
        this.createdAt = res.createdAt;
        this.album = res.media;
        this.initCrumbs();

        if (res.url && res.mimeType === 'application/x-zip-compressed') {
          this.extractZipFile(res.url);
        } else {
          this.loading = false;
        }
      });
    }
  }

  // Open image modal
  openImageModal(imageUrl: string): void {
    this.selectedImage = imageUrl;
    this.isModalOpen = true;
  }

  // Close the image modal
  closeImageModal(): void {
    this.isModalOpen = false;
    this.selectedImage = '';  // Clear the selected image URL
  }

  async extractZipFile(zipUrl: string) {
    try {
      const response = await fetch(zipUrl);
      const zipBlob = await response.blob();
      const zip = await JSZip.loadAsync(zipBlob);

      const imagePromises: any[] = [];
      const videoPromises: any[] = [];

      zip.forEach((relativePath, file) => {
        if (file.name.match(/\.(png|jpg|jpeg)$/i)) {
          // Handle image files
          const promise = file.async('blob').then((blob) => {
            const imageUrl = URL.createObjectURL(blob);
            this.extractedImages.push(imageUrl);
          });
          imagePromises.push(promise);
        } else if (file.name.match(/\.(mp4|webm|mov)$/i)) {
          // Handle video files
          const promise = file.async('blob').then((blob) => {
            const videoUrl = URL.createObjectURL(blob);
            this.extractedVideos.push(videoUrl);
          });
          videoPromises.push(promise);
        }
      });

      await Promise.all([...imagePromises, ...videoPromises]);
    } catch (error) {
      console.error('Error extracting ZIP file:', error);
    } finally {
      this.loading = false;  // Hide loader after extraction
    }
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      { title: 'Media Gallery', route: '/admin/media' },
      { title: this.title },
    ];
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  showModal(item: any): void {
    this.isVisible = true;
    this.mediaItem = item;
  }

  handleCancel(): void {
    this.isVisible = false;
  }
}
